import React from 'react'
import { UilTimes } from '@iconscout/react-unicons'
import dayjs from 'dayjs'
import VideoJS from './VideoPlayer';


export default function PreviewCampaign({ promo, close }) {
  console.log(promo?.schedules)
  return (
    <div className={`bg-black fixed top-0 left-0 bg-opacity-30 flex z-50 w-screen h-screen`}>
      <div className="lg:max-w-lg rounded-xl lg:w-full w-11/12 bg-white text-placeholder pb-5 m-auto max-h-[550px] overflow-hidden">
        <div className="relative p-3">
          <h3 className="text-xl text-center text-secondary font-semibold w-full">Campaign preview</h3>

          <UilTimes
            className="absolute top-2 right-2 text-placeholder text-3xl cursor-pointer"
            onClick={close}
          />
        </div>

        <ul className="overflow-x-hidden h-full max-h-[470px] px-4">
          <>
            <li className="grid grid-cols-2 py-2">
              <label className="grow block">Title</label>
              <span className="">{promo?.title}</span>
            </li>
            <li className="grid grid-cols-2 py-2">
              <label className="grow block">Campaign type</label>
              <span className="">{promo?.type}</span>
            </li>
            <li className="grid grid-cols-2 py-2">
              <label className="grow block">Budget</label>
              <span className="">{promo?.budget}</span>
            </li>
            <li className="grid grid-cols-2 py-2">
              <label className="grow block">Message</label>
              <span className="">{promo?.message}</span>
            </li>
            <li className="grid grid-cols-2 py-2">
              <label className="grow block">Start date</label>
              <span className="">{dayjs(promo?.start).format('DD-MM-YYYY')}</span>
            </li>
            <li className="grid grid-cols-2 py-2">
              <label className="grow block">End date</label>
              <span className="">{dayjs(promo?.end).format('DD-MM-YYYY')}</span>
            </li>
            <li className="grid grid-cols-2 py-2">
              <label className="grow block">Status</label>
              <div>
                <span className={`p-0.5 rounded-md ${promo?.status === 'pending' ? 'bg-yellow-200 text-yellow-600' : promo?.status === 'success' ? 'bg-green-200 text-success' : 'bg-red-200 text-danger'} px-3`}>{`${promo?.status.charAt(0).toUpperCase()}${promo?.status.slice(1)} `}</span>
              </div>
            </li>
            <li className="grid grid-cols-2 py-2">
              <label className="grow block">Blocked</label>
              <div>
                <span className="p-0.5 rounded-md bg-green-200 text-success px-3">{promo?.blocked ? 'Yes' : 'No'}</span>
              </div>
            </li>
            <li className="grid grid-cols-2 py-2">
              <label className="grow block">Impressions</label>
              <span className="">{promo?.impressions}</span>
            </li>
            <li className="grid grid-cols-2 py-2">
              <label className="grow block">Frequency</label>
              <span className="">{promo?.frequency.name}</span>
            </li>
            <li className="grid grid-cols-2 py-2">
              <label className="grow block">Schedule</label>
              <span className="">{promo?.schedules?.map(x => <>{x?.day}, from:  {x?.from['name_12']} to: {x?.to['name_12']} <br /></>)}</span>
            </li>
            <li className="grid grid-cols-2 p border-b">
              <label className="grow block font-medium text-lg py-2">Target audience info</label>
            </li>
            <li className="grid grid-cols-2 py-2">
              {/* <video src={promo?.media_stream} poster={promo?.thumbnail_stream} controls /> */}
              <VideoJS options={{
                autoplay: true,
                controls: true,
                responsive: true,
                fluid: true,
                sources: [{
                  src: promo?.media_stream,
                  type: 'application/x-mpegURL'
                }]
              }}/>
            </li>
          </>
        </ul>
      </div>
    </div>
  )
}
